/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";
import AttributeDisplayListItem from "./AttributeDisplayListItem";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import PropTypes, { string, number } from "prop-types";
import "./AttributeDisplays.css";

/**
 * This component takes in a list of attributes and displays them in a react-bootstrap ListGroup
 * @param {Array} attributes - The array of attribute objects.
 */
const AttributeDisplayList = ({ attributes }) => {
	return (
		<ListGroup variant="flush" className="attributes-display-list">
			{attributes &&
				attributes.map((attribute) => (
					<ListGroupItem style={{ padding: "5px 15px" }} key={attribute.id}>
						<AttributeDisplayListItem attribute={attribute} />
					</ListGroupItem>
				))}
		</ListGroup>
	);
};

AttributeDisplayList.propTypes = {
	attributes: PropTypes.arrayOf(
		PropTypes.exact({ id: string, order: number, name: string, value: string, prefix: string }),
	),
};

export default AttributeDisplayList;
